import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var Subtitle = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M6.698 22.632a7.984 7.984 0 0 1 7.981-7.981c1.704 0 3.268.536 4.56 1.435a.75.75 0 0 1-.856 1.231 6.447 6.447 0 0 0-3.704-1.166 6.484 6.484 0 0 0-6.481 6.48 6.476 6.476 0 0 0 10.185 5.315.75.75 0 1 1 .857 1.232 7.976 7.976 0 0 1-12.542-6.546ZM24.425 22.632a7.984 7.984 0 0 1 7.982-7.981c1.704 0 3.268.536 4.56 1.435a.75.75 0 0 1-.856 1.231 6.447 6.447 0 0 0-3.704-1.166 6.484 6.484 0 0 0-6.481 6.481 6.484 6.484 0 0 0 6.48 6.481c1.371 0 2.651-.433 3.705-1.166a.75.75 0 0 1 .856 1.231 7.977 7.977 0 0 1-4.56 1.435 7.984 7.984 0 0 1-7.981-7.98Z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.896 40.844H2.104A2.106 2.106 0 0 1 0 38.74V6.524C0 5.364.944 4.42 2.104 4.42h39.792c1.16 0 2.104.944 2.104 2.104V38.74c0 1.16-.944 2.104-2.104 2.104Zm0-1.5H2.104a.606.606 0 0 1-.604-.604V6.524c0-.332.272-.604.604-.604h39.792c.332 0 .604.272.604.604V38.74a.606.606 0 0 1-.604.604Z"
  }));
});
Subtitle.displayName = 'Subtitle';
Subtitle.defaultProps = {
  'aria-label': 'Subtitle'
};
export default Subtitle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Web/Subtitle.js
// module id = 3296
// module chunks = 11